<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <issue-panel/>
    </div>
  </div>
</template>

<script>
import IssuePanel from "../Issues/IssuePanel";
export default {
  components: { IssuePanel },
  data() {
    return {};
  }
};
</script>
